import { useQuery } from '@tanstack/react-query'

import {
  CollateralAtRiskDataPoint,
  collateralAtRiskQueryOptions,
} from './collateral-at-risk-query/collateralAtRiskQuery'
import { SimplifiedQueryResult } from '@/domain/common/query'

export interface UseCollateralAtRiskDataOptions {
  enabled?: boolean
}

export type UseCollateralAtRiskDataResult = SimplifiedQueryResult<CollateralAtRiskDataPoint[]>

export function useCollateralAtRiskData({
  enabled = true,
}: UseCollateralAtRiskDataOptions): SimplifiedQueryResult<CollateralAtRiskDataPoint[]> | undefined {
  const queryResult = useQuery({
    ...collateralAtRiskQueryOptions(),
    enabled,
  })

  if (!enabled) {
    return undefined
  }

  return queryResult
}
